import { AfterViewInit, ChangeDetectorRef, Component, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSelect, MatSelectChange } from '@angular/material/select';
import { MatSort } from '@angular/material/sort';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { FilterService } from '../../../services/filter.service';
import { Filter } from '../../../models/review/filter.model';
import { UserConfigsService } from 'src/app/services/user-configs.service';
import { Role } from 'src/app/models/role.model';
import { UserConfigs } from 'src/app/models/user-configs.model';
import { BehaviorSubject, combineLatest, Observable, of, Subscription } from 'rxjs';
import { Field } from 'src/app/models/field/field.model';
import { DisplayType } from 'src/app/models/field/display-type.enum';
import { ControlModuleId } from '../../../models/control-module-id.enum';
import { MultiSort, SelectSortComponent } from '../../dialogs/select-sort/select-sort.component';
import { SelectFilterComponent } from 'src/app/components/dialogs/select-filter/select-filter.component';
import { SavedFilters } from 'src/app/models/SavedFilters';
import { CreateBriefcaseComponent } from '../../dialogs/create-briefcase/create-briefcase.component';
import { BriefcaseJob } from '../../../models/review/briefcase-job.model';
import { CodingFieldsService } from '../../../services/coding-fields.service';
import { CustomCodingFieldsManager } from '../../../models/review/custom-coding-fields-manager';
import { SortProcessor } from '../../../models/review/sort-processor';
import { ExportLogService } from '../../../services/export-log.service';
import { ExportLog } from '../../../models/export-log.model';
import { MultiDocGroup } from '../../../models/field/multi-doc-field.model';
import { SelectFolderComponent } from 'src/app/components/dialogs/select-folder/select-folder.component';
import { FolderResource } from '../../../models/resource/folder.resource';
import { ActivatedRoute, Router } from '@angular/router';
import { FolderSdk } from '../../../sdks/folder.sdk';
import { ColumnResizer } from './column-resizer';
import { catchError, skip, switchMap, take, tap } from 'rxjs/operators';
import { DocCoding } from '../../../models/doc-coding.model';
import { BuiltInFieldId } from '../../../models/built-in-field-id.enum';
import { DocBates } from '../../../models/doc-bates.model';
import { SelectionService } from '../../../models/review/selection-service';
import { ByteSize } from '../../../models/byte-size.model';
import { MenuResizer } from './menu-resizer';
import { SessionService } from 'src/app/services/session.service';
import { TextGroupManager } from '../../../models/review/text-group-manager';
import { FilterExpanderState } from '../../../models/review/filter-expander-state';
import { RowDensityManager } from 'src/app/services/row-density-manager';
import { FieldLayoutViewModelService } from '../../../services/field-layout-view-model.service';
import { FieldLayoutViewModel, FieldViewModel } from '../../../models/field/field-layout-view-model.model';
import { SelectFieldsDialogComponent } from '../../dialogs/select-fields/select-fields.component';
import { DocIssueType, DocIssueTypeExtension } from '../../../models/doc-issue-type.enum';
import { HelpService } from '../../../services/help.service';
import { BuiltInFieldsService } from '../../../services/built-in-fields.service';
import { FilterQuickLinks } from '../quick-links/filter-quick-links';
import { SearchQuickLinks } from '../quick-links/search-quick-links';
import { SavedSearch } from '../../../models/review/saved-search.model';
import { SavedSearchesService } from '../../../services/saved-searches.service';
import { QuickLinkManagementComponent } from 'src/app/components/dialogs/quick-link-management/quick-link-management.component';
import { NotificationHubSdk } from 'src/app/sdks/notification.hub-sdk';
import { SearchParameter } from '../../../models/review/search-parameter.model';
import { FieldType } from 'src/app/models/field/field-type.enum';
import { QuickLinks } from '../quick-links/quick-links';
import { QuickLinkUpdate } from '../quick-links/quick-link-update';
import { QuickLink } from 'src/app/models/quick-link-model';
import { OkCancelDialogComponent } from 'src/app/components/dialogs/ok-cancel/ok-cancel-dialog.component';
import { ManageDefaultsComponent } from 'src/app/components/dialogs/manage-defaults/manage-defaults.component';
import { LayoutQuickLink } from '../quick-links/layout-quick-link';
import { LayoutQuickLinks } from '../quick-links/layout-quick-links';
import { EmailThreadGroupingsService } from 'src/app/services/email-thread-groupings.service';
import { SearchReportService } from '../../../services/search-report.service';
import { FeatureConfigService } from '../../../services/feature-config.service';
import { EmailType } from '../../../models/email-type.model';
import { SelectFilterNewComponent } from 'src/app/components/dialogs/select-filter-new/select-filter-new.component';
import { HideShowService } from 'src/app/services/hide-show.service';
import { FilterMatch, FilterType, SavedFilter } from 'src/app/components/dialogs/select-filter-new/models/saved-filter';
import { FilterFieldGuids } from 'src/app/components/dialogs/select-filter-new/models/filter-field-guids';
import { FieldDisplayType } from 'src/app/components/dialogs/select-filter-new/models/field-display-type';
import { FilterComparerGuids } from 'src/app/components/dialogs/select-filter-new/models/filter-comparer-guids';
import { BrowseManager } from '../../../managers/browse.manager';
import { ErrorHandlerService } from '../../../services/error-handler.service';
import { NotificationManager } from '../../../managers/notification.manager';
import { BriefcaseManager } from "../../../managers/briefcase.manager";
import { AiMultiDocPromptComponent } from '../ai-multi-doc-prompt/ai-multi-doc-prompt.component';
import { ThirdPartySettings } from '@store/third-party/third-party.state';
import { currentOpenAiSettings } from '@store/third-party/open-ai-settings/open-ai-settings.selector';
import { Store } from '@ngrx/store';
import { AiPilotPromptComponent } from '../ai-pilot-prompt/ai-pilot-prompt.component';
import { CaseConfigService } from '@services/case-config.service';
import { CaseConfigTypeId } from '@models/case-config-type.enum';
import { CaseConfig } from '@models/case-config.model';
import { selectIsIndexingAndIsProcessing } from "@store/global/global.selectors";
import { ProcessingManager } from '@managers/processing.manager';

@Component({
	selector: 'lex-browse',
	templateUrl: './browse.component.html',
	styleUrls: ['./browse.component.scss'],
	standalone: false
})
export class BrowseComponent implements OnInit, AfterViewInit, OnDestroy {

	public Role = Role;
	public hasActiveSearch = false;
	/** Select column and ids of displayed columns. */
	columnsToDisplay: string[];
	scoreFieldViewModel: FieldViewModel = {
		fieldLayoutId: null,
		fieldId: '5aea565f-8b57-4124-8fd6-01f0587c0f68',
		parentFieldId: null,
		displayTitle: 'Score',
		fieldType: FieldType.BuiltInFieldInt32,
		displayType: DisplayType.Numeric,
		rank: 1,
		path: 'searchMetadata.score',
		width: 47,
		databaseTitle: 'Score'
	};
	/** Custom coding fields manager that houses custom coding fields, their selection status, and hierarchical relationships. */
	ccfManager: CustomCodingFieldsManager;
	filterQuickLinks: FilterQuickLinks;
	public searchQuickLinks: SearchQuickLinks;
	layoutQuickLinks: LayoutQuickLinks;
	controlModuleIds = ControlModuleId;
	sortAlert: [MultiSort, string, string];
	disableSortChange = false;
	userRoles: Role[] = null;
	userConfig: UserConfigs;
	DisplayType = DisplayType;
	sortProcessor: SortProcessor;
	multiDocGroups: MultiDocGroup[] = [];
	operationsUser: boolean = false;
	columnResizer: ColumnResizer;
	menuResizer: MenuResizer;
	builtInFieldIds = BuiltInFieldId;
	displayedFieldLayout: FieldLayoutViewModel = {
		fieldLayoutId: null,
		displayTitle: null,
		modifiedByUserId: null,
		modifiedDateTime: null,
		isPinned: false,
		isShared: false,
		fields: []
	};
	folderNavigationList: FolderResource[] = [];
	rootFolderId: string;
	timeoutAlert = false;
	public noDocuments = false;
	invalidQuery = false;
	truncatedResult = false;
	public syntaxWarning: BehaviorSubject<string> = new BehaviorSubject<string>('');
	filterExpanderState: FilterExpanderState = {
		IsDocumentsExpanded: true,
		IsDiscoveryExpanded: true,
		IsGeneralCodingExpanded: true,
		IsDynamicCodingExpanded: true
	};
	rowDensityManger: RowDensityManager;
	previousFilterId: string;
	hasAutoRedactionFilter = false;
	saveSearch = false;
	wordWrap = false;
	expandEmailFamilySelected = false;
	enableFeatureExpandToEmailFamily = false;
	exportingLog = false;

	readonly fixedColumnTitles: string[] = ['row-number', 'select'];
	fixedColumnCount: number = this.fixedColumnTitles.length;

	private subscription = new Subscription();
	private searchIncompleteProcessing = 'Search results may be incomplete because items are still being processed or indexed.';
	private searchIncompleteIndexing = 'Search results may be incomplete because the case index is out-of-sync.';

	private openAiSettings$: Observable<ThirdPartySettings> = this.store.select(currentOpenAiSettings());
	private isOpenAiLinked: boolean = false;

	private enableKnowledgeBase: boolean = false;
	private refresh: string[] = [];
	private needRefresh: boolean = false;

	@ViewChild(MatSort, { static: true }) sort: MatSort;
	@ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

	get EmailType(): typeof EmailType {
		return EmailType;
	}

	hideShowFunc;
	showLeftPane = true;
	isProcessingOrIndexing: boolean = false;

	constructor(
		public filterService: FilterService,
		public selectionService: SelectionService,
		public fieldLayoutViewModelService: FieldLayoutViewModelService,
		public savedSearchesService: SavedSearchesService,
		public userConfigService: UserConfigsService,
		codingFieldsService: CodingFieldsService,
		sessionService: SessionService,
		builtInFieldsService: BuiltInFieldsService,
		private featureConfigService: FeatureConfigService,
		private dialog: MatDialog,
		private briefcaseManager: BriefcaseManager,
		private exportService: ExportLogService,
		private activatedRoute: ActivatedRoute,
		private folderService: FolderSdk,
		private changeDetectorRef: ChangeDetectorRef,
		private helpService: HelpService,
		private notificationHubSdk: NotificationHubSdk,
		private emailThreadService: EmailThreadGroupingsService,
		private searchReportService: SearchReportService,
		private hideShowService: HideShowService,
		private browseManager: BrowseManager,
		private errorHandler: ErrorHandlerService,
		private notificationManager: NotificationManager,
		public textGroupManager: TextGroupManager,
		private router: Router,
		private store: Store,
		private caseConfigService: CaseConfigService,
		private processingManager: ProcessingManager
	) {
		this.ccfManager = new CustomCodingFieldsManager(codingFieldsService);
		this.sortProcessor = new SortProcessor(builtInFieldsService, this.ccfManager);
		this.columnResizer = new ColumnResizer();
		this.menuResizer = new MenuResizer();
		this.selectionService.resetState();
		this.selectionService.dataSource.onError.on('doc-error', () => this.timeoutAlert = true);
		this.selectionService.dataSource.onError.on('no-docs-error', () => this.noDocuments = true)
		this.selectionService.dataSource.onError.on('query-error', () => this.invalidQuery = true);
		this.textGroupManager.onGroupChange.on(this.textGroupManager.groupChangeEventName, (textGroupId: string, filter: SavedFilter) => {
			this.saveAndSetFilter(filter);
			this.router.navigate([], {
				relativeTo: this.activatedRoute, queryParams: { TextGroupId: textGroupId, ShowTextGroups: true }
			});
		});
		this.rowDensityManger = new RowDensityManager(sessionService);
		this.rowDensityManger.initialize();
		this.filterQuickLinks = new FilterQuickLinks(filterService);
		this.searchQuickLinks = new SearchQuickLinks(savedSearchesService);
		this.layoutQuickLinks = new LayoutQuickLinks(fieldLayoutViewModelService);
		this.hideShowFunc = (show) => this.showLeftPane = show;
		hideShowService.onChange.on(hideShowService.eventName, this.hideShowFunc);
		this.showLeftPane = hideShowService.show;
	}

	ngOnInit() {
		this.columnResizer.columnResized.subscribe(fvm => this.saveColumnResize(fvm));
		const userConfigObservable = this.userConfigService.getUserConfigs();
		const fieldLayoutObservable = this.fieldLayoutViewModelService.getActiveLayout();
		const filterObservable = this.activateFilterFromQueryString();

		this.subscription.add(
			combineLatest([userConfigObservable, fieldLayoutObservable, filterObservable])
				.pipe(take(1))
				.subscribe(data => {
					// data is an array of last subscriptions (next) of each of the observables above in the same order
					this.refreshUserConfig(data[0]);

					this.displayedFieldLayout = data[1];
					this.setColumnsToDisplay();
					this.setFieldsToDisplay();

					this.expandEmailFamilySelected = data[2];
					this.load(this.paginator.pageIndex, false);

					this.changeDetectorRef.detectChanges();
				}));

		this.subscription.add(
			userConfigObservable
				.pipe(skip(1))
				.subscribe(next =>
					this.refreshUserConfig(next)));

		this.subscription.add(
			this.featureConfigService.featureConfig$
				.subscribe(sc =>
					this.enableFeatureExpandToEmailFamily = sc.enableFeatureExpandToEmailFamily));

		this.subscription.add(
			this.openAiSettings$
				.subscribe(settings =>
					this.isOpenAiLinked = settings.isLinked));

		this.subscription.add(
			this.processingManager.workflows$
				.subscribe((x) => {
					let reload = false;
					if (x.some(y => y.workflowName === 'BulkDeleteDocsWorkflow'))
						x.filter(y => y.workflowName === 'BulkDeleteDocsWorkflow')?.every((workflow) => {
							if (!this.refresh.some(z => z === workflow.workflowKey)) {
								this.refresh.push(workflow.workflowKey)
							}
						});
					this.refresh.every((workflowKey, index, object) => {
						if (!x.some(y => y.workflowKey === workflowKey)) {
							object.splice(index, 1);
							reload = true;
						}
					})
					if (reload) {
						if (this.refresh.length === 0 && this.selectionService.operationAlert === 'The documents are being deleted. This may take a few moments.')
							this.selectionService.operationAlert = null;
						this.load(this.paginator.pageIndex, false);
						this.needRefresh = false;
					}
					else if (this.needRefresh && this.refresh.length === 0 && x.length === 0) {
						if (this.selectionService.operationAlert === 'The documents are being deleted. This may take a few moments.')
							this.selectionService.operationAlert = null;
						this.load(this.paginator.pageIndex, false);
						this.needRefresh = false;
					}
				}));

		this.filterQuickLinks.initialize();
		this.searchQuickLinks.initialize();
		this.layoutQuickLinks.initialize();

		this.ccfManager.retrieve();
		const page = 'shared-functions';
		this.helpService.updateHelpLink(page);

		this.subscription.add(this.store.select(selectIsIndexingAndIsProcessing).subscribe(notification => this.notificationChanged(notification)));

		this.subscription.add(
			this.browseManager.currentFilters$
				.pipe(skip(1))
				.subscribe((x) => x ? this.saveAndSetFilter(x) : this.clearFilter()));

		this.subscription.add(
			this.caseConfigService.getCaseConfigs(this.userConfigService.currentConfig.currentCase.caseId).subscribe(data => {
				this.enableKnowledgeBase = JSON.parse(data.filter((config: CaseConfig) => config.configTypeId === CaseConfigTypeId.EnableKnowledgeBase)[0].value);
			})
		);
	}

	ngAfterViewInit() {
		this.paginator.page
			.subscribe((pe: PageEvent) => {
				this.selectionService.pageSize = pe.pageSize;
				this.load(pe.pageIndex);
			});

		this.sort.sortChange
			.subscribe(() => {
				if (!this.disableSortChange) {
					this.sortAlert = null;
					this.load(0);
				}
			});

		// Back-end sorts by Doc Title by default for Browse
		this.sort.active = this.builtInFieldIds.DocTitle;
		this.sort.direction = 'asc';
		this.sort.disableClear = true;
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
		this.hideShowService.onChange.removeListener(this.hideShowService.eventName, this.hideShowFunc);
		this.browseManager.reset();
	}

	@HostListener('window:mousemove', ['$event'])
	windowMouseMove(event: MouseEvent) {
		this.columnResizer.mouseMove(event);
		this.menuResizer.mouseMove(event);
	}

	@HostListener('window:mouseup')
	windowMouseUp() {
		this.columnResizer.mouseUp();
		this.menuResizer.mouseUp();
	}


	private saveColumnResize(fieldViewModel: FieldViewModel) {
		const index = this.displayedFieldLayout.fields.findIndex(f => f.fieldId === fieldViewModel.fieldId);
		this.displayedFieldLayout.fields[index] = fieldViewModel;
		this.layoutQuickLinks.addNew(this.displayedFieldLayout.fields);
	}

	private refreshUserConfig(userConfig: UserConfigs): void {
		const oldCaseId = this.userConfig ? this.userConfig.currentCase.caseId : null;
		this.userConfig = userConfig;
		this.userRoles = userConfig.userRoles;
		if (this.userConfigService.inRoles(Role.Operations))
			this.operationsUser = true;

		if (oldCaseId && oldCaseId !== this.userConfig.currentCase.caseId)
			this.handleCaseChange();
	}

	private handleCaseChange(): void {
		const fieldLayoutObservable = this.fieldLayoutViewModelService.getActiveLayout();

		combineLatest([fieldLayoutObservable])
			.subscribe(data => {
				// data is an array of last subscriptions (next) of each of the observables above in the same order
				this.displayedFieldLayout = data[0];
				this.setColumnsToDisplay();
				this.setFieldsToDisplay();
				this.layoutQuickLinks.initialize();

				this.selectionService.resetState();
				this.expandEmailFamilySelected = false;

				this.load(0);
			});
	}

	private notificationChanged(notification: { isProcessing: boolean, isIndexing: boolean }) {
		this.isProcessingOrIndexing = notification.isIndexing || notification.isProcessing;

		if (this.selectionService.searchOperationAlert === this.searchIncompleteIndexing
			|| this.selectionService.searchOperationAlert === this.searchIncompleteProcessing) {
			this.selectionService.searchOperationAlert = null;
		}
		if (notification.isProcessing) {
			this.selectionService.searchOperationAlert = this.searchIncompleteProcessing;
		} else {
			if (notification.isIndexing) {
				this.selectionService.searchOperationAlert = this.searchIncompleteIndexing;
			} else if (this.userConfigService.inRoles(Role.Operations, Role.Developer)) {
				const currentCase = this.userConfigService.currentConfig.currentCase;
				if (currentCase.indexDocCount !== currentCase.caseDocCount) {
					this.selectionService.searchOperationAlert = this.searchIncompleteIndexing;
				}
			}
		}
	}

	shouldSortBeDisabled(field: FieldViewModel): boolean {
		// Sorting is available on every column in Browse
		// Sorting is only available on the Master Date column in Search
		return this.hasActiveSearch && field.fieldId !== BuiltInFieldId.MasterDate;
	}

	hasCodingField = (fields: FieldViewModel[]) => fields.some(f => f.fieldType >= 0);

	dropListDropped(event: CdkDragDrop<any, any>) {
		if (!event)
			return;

		const previousIndex = event.previousIndex;
		let currentIndex = event.currentIndex;
		let titleIndex = this.displayedFieldLayout.fields.findIndex(f => f.fieldId === BuiltInFieldId.DocTitle);
		let scoreIndex = this.displayedFieldLayout.fields.findIndex(f => f.fieldId === BuiltInFieldId.Score);

		const previousColumnIndex = previousIndex + this.fixedColumnCount;
		const currentColumnIndex = currentIndex + this.fixedColumnCount;
		const titleColumnIndex = titleIndex + this.fixedColumnCount;
		const scoreColumnIndex = scoreIndex + this.fixedColumnCount;

		if (this.hasActiveSearch && titleIndex === previousIndex) {
			moveItemInArray(this.displayedFieldLayout.fields, previousIndex, currentIndex);
			moveItemInArray(this.columnsToDisplay, previousColumnIndex, currentColumnIndex);

			scoreIndex = this.displayedFieldLayout.fields.findIndex(f => f.fieldId === BuiltInFieldId.Score);
			titleIndex = this.displayedFieldLayout.fields.findIndex(f => f.fieldId === BuiltInFieldId.DocTitle);

			if (scoreIndex > titleIndex)
				titleIndex++;

			moveItemInArray(this.displayedFieldLayout.fields, scoreIndex, titleIndex);
			moveItemInArray(this.columnsToDisplay, scoreColumnIndex, titleColumnIndex);

		} else if (this.hasActiveSearch && scoreIndex === previousIndex) {
			moveItemInArray(this.displayedFieldLayout.fields, previousIndex, currentIndex);
			moveItemInArray(this.columnsToDisplay, previousColumnIndex, currentColumnIndex);

			scoreIndex = this.displayedFieldLayout.fields.findIndex(f => f.fieldId === BuiltInFieldId.Score);
			titleIndex = this.displayedFieldLayout.fields.findIndex(f => f.fieldId === BuiltInFieldId.DocTitle);

			if (titleIndex < scoreIndex)
				scoreIndex--;

			moveItemInArray(this.displayedFieldLayout.fields, titleIndex, scoreIndex);
			moveItemInArray(this.columnsToDisplay, titleColumnIndex, scoreColumnIndex);

		} else {
			if (this.hasActiveSearch && currentIndex >= titleIndex && currentIndex <= scoreIndex) {
				if (previousIndex < titleIndex) { // moved right
					currentIndex = scoreIndex;
				} else {
					currentIndex = titleIndex;
				}
			}
			moveItemInArray(this.displayedFieldLayout.fields, previousIndex, currentIndex);
			moveItemInArray(this.columnsToDisplay, previousColumnIndex, currentColumnIndex);
		}

		this.displayedFieldLayout.fields.forEach((field, idx) => field.rank = idx);
		this.layoutQuickLinks.addNew(this.displayedFieldLayout.fields);
	}

	// Returns whether it has activated a filter
	activateFilterFromQueryString(): Observable<boolean> {
		return this.activatedRoute.queryParams
			.pipe(
				switchMap(params => {
					const docExtension = params['DocExtension'];
					const custodianId = params['CustodianId'];
					const emailThreadId = params['EmailThreadId'];
					const excludeRedundantEmails = params['ExcludeRedundantEmails'];
					const reviewSetId = params['ReviewSetId'];
					const uploadBatchId = params['UploadBatchId'];
					const productionJobId = params['ProductionJobId'];
					const archiveJobId = params['ArchiveJobId'];
					const briefcaseJobId = params['BriefcaseJobId'];
					const assistedReviewBatchId = params['AssistedReviewBatchId'];
					const textGroupId = params['TextGroupId'];
					const showTextGroups = params['ShowTextGroups'] ? params['ShowTextGroups'] : false;
					let autoRedactionRuleIds = params['AutoRedactionRuleIds'];
					const productionValidator = params['ProductionValidator'];
					const productionValidationJobId = params['ProductionValidationJobId'];
					const searchReportId = params['SearchReportId'];
					let searchReportQueryIds = params['SearchReportQueryIds'];
					const isSearch: boolean = params['IsSearch'] ?? false;
					const uniqueSearchQueryResults: boolean = params['UniqueSearchQuery'] ? params['UniqueSearchQuery'] : false;
					const expandToEmailFamily: boolean = params['ExpandToEmailFamily'] ? params['ExpandToEmailFamily'] : false;
					const issues = params['Issues'];

					if (params['q']) {
						this.searchQuickLinks.searchParameter = new SearchParameter(params['q']);
						this.doSearch(false);
					}

					if (searchReportId && isSearch && searchReportQueryIds) {
						if (Array.isArray(searchReportQueryIds))
							searchReportQueryIds = searchReportQueryIds.shift();
						this.searchReportService.getSearchReport(searchReportId).pipe(
							switchMap(sr => {
								this.searchQuickLinks.searchParameter = new SearchParameter(sr.searchReportQueries.find(q => q.searchReportQueryId == searchReportQueryIds).query);
								if (sr.filterId)
									return of(sr.filterId);
								else
									return of(null);
							}),
							switchMap(filterId => {
								if (filterId)
									return this.filterService.getFilter(filterId);
								else {
									this.doSearch(false);
									return of(null);
								}
							})).subscribe((data: Filter) => {
								if (data) {
									this.setFilter(data);
									this.doSearch(false);
								}
							});
						return of(false);
					}

					if (showTextGroups) {
						this.textGroupManager.initialize(textGroupId);
					}

					if (!docExtension
						&& !custodianId
						&& !emailThreadId
						&& !excludeRedundantEmails
						&& !reviewSetId
						&& !uploadBatchId
						&& !productionJobId
						&& !archiveJobId
						&& !briefcaseJobId
						&& !assistedReviewBatchId
						&& !textGroupId
						&& !autoRedactionRuleIds
						&& (!productionValidator && !productionValidationJobId)
						&& (!searchReportQueryIds && !searchReportId && !isSearch)
						&& !expandToEmailFamily
						&& !issues
					)
						return of(false);

					const filter: SavedFilter = {
						type: FilterType.Simple,
						match: FilterMatch.All,
						not: false,
						fields: []
					};

					if (docExtension) filter.fields.push({
						fieldId: BuiltInFieldId.DocExtension,
						displayType: FieldDisplayType.Text,
						comparer: FilterComparerGuids.Contains,
						value: [docExtension]
					});
					if (custodianId) filter.fields.push({
						fieldId: BuiltInFieldId.Custodian,
						displayType: FieldDisplayType.MultiSelect,
						comparer: FilterComparerGuids.Is,
						value: [custodianId]
					});
					if (emailThreadId) filter.fields.push({
						fieldId: FilterFieldGuids.EmailThreadId,
						displayType: FieldDisplayType.Text,
						comparer: FilterComparerGuids.Is,
						value: [emailThreadId]
					});
					if (excludeRedundantEmails) filter.fields.push({
						fieldId: FilterFieldGuids.ExcludeRedundantEmails,
						displayType: FieldDisplayType.Boolean,
						comparer: null,
						value: [excludeRedundantEmails]
					});
					if (reviewSetId) filter.fields.push({
						fieldId: FilterFieldGuids.ReviewSetId,
						displayType: FieldDisplayType.MultiSelect,
						comparer: FilterComparerGuids.Is,
						value: [reviewSetId]
					});
					if (uploadBatchId) filter.fields.push({
						fieldId: BuiltInFieldId.UploadBatchId,
						displayType: FieldDisplayType.MultiSelect,
						comparer: FilterComparerGuids.Is,
						value: [uploadBatchId]
					});
					if (productionJobId) filter.fields.push({
						fieldId: FilterFieldGuids.ProductionJobId,
						displayType: FieldDisplayType.MultiSelect,
						comparer: FilterComparerGuids.Is,
						value: [productionJobId]
					});
					if (archiveJobId) filter.fields.push({
						fieldId: FilterFieldGuids.ArchiveJob,
						displayType: FieldDisplayType.MultiSelect,
						comparer: FilterComparerGuids.Is,
						value: [archiveJobId]
					});
					if (briefcaseJobId) filter.fields.push({
						fieldId: FilterFieldGuids.BriefcaseJobId,
						displayType: FieldDisplayType.MultiSelect,
						comparer: FilterComparerGuids.Is,
						value: [briefcaseJobId]
					});
					if (assistedReviewBatchId) filter.fields.push({
						fieldId: FilterFieldGuids.AssistedReviewBatch,
						displayType: FieldDisplayType.MultiSelect,
						comparer: FilterComparerGuids.Is,
						value: [assistedReviewBatchId]
					});
					if (textGroupId) filter.fields.push({
						fieldId: BuiltInFieldId.TextGroupId,
						displayType: FieldDisplayType.Text,
						comparer: FilterComparerGuids.Is,
						value: [textGroupId]
					});

					if (autoRedactionRuleIds) {
						if (!Array.isArray(autoRedactionRuleIds))
							autoRedactionRuleIds = [autoRedactionRuleIds];
						filter.fields.push({
							fieldId: FilterFieldGuids.AutoRedactionRuleId,
							displayType: FieldDisplayType.MultiSelect,
							comparer: FilterComparerGuids.Is,
							value: autoRedactionRuleIds
						});
					}

					if (productionValidator && productionValidationJobId) {
						const values = [productionValidator, productionValidationJobId];
						filter.fields.push({
							fieldId: FilterFieldGuids.ProductionValidation,
							displayType: FieldDisplayType.MultiSelect,
							comparer: FilterComparerGuids.Is,
							value: values
						});
					}

					if (searchReportQueryIds && searchReportId) {
						if (!Array.isArray(searchReportQueryIds))
							searchReportQueryIds = [searchReportQueryIds];
						filter.fields.push({
							fieldId: searchReportId,
							displayType: FieldDisplayType.SearchReport,
							comparer: FilterComparerGuids.Is,
							value: [uniqueSearchQueryResults, ...searchReportQueryIds]
						});
					}

					if (issues) filter.fields.push({
						fieldId: BuiltInFieldId.Issues,
						displayType: FieldDisplayType.StaticDropdown,
						comparer: FilterComparerGuids.Is,
						value: [issues]
					});

					return this.filterService.saveFilter(filter)
						.pipe(
							tap(r => this.updateFilter(r)),
							switchMap(() => of(expandToEmailFamily)));
				}));
	}

	selectFolder() {
		const dialogRef = this.dialog.open(SelectFolderComponent, {
			width: '600px'
		});

		dialogRef.afterClosed().subscribe((path: FolderResource[]) => {
			if (!path) return;

			// Path always ends at the selected folder - so just pick the last one
			this.navigateFolder(path[path.length - 1].folderId);
		});
	}

	handleDocsAdded(success: boolean, change: MatSelectChange) {
		const matSelect: MatSelect = change.source;
		matSelect.writeValue(null);
		let feedback = '';
		if (success === true)
			feedback = 'Documents added';
		else if (success === false)
			feedback = 'Documents have already been added';
		else
			feedback = 'There was an error';

		this.selectionService.operationAlert = feedback;
	}

	setColumnsToDisplay() {
		this.columnsToDisplay = this.fixedColumnTitles.concat(this.displayedFieldLayout.fields.map(f => f.fieldId));

		const scoreIdx = this.columnsToDisplay.findIndex(c => c === BuiltInFieldId.Score);
		if (scoreIdx !== -1)
			this.columnsToDisplay.splice(scoreIdx, 1);

		if (this.hasActiveSearch) {
			const titleIdx = this.columnsToDisplay.findIndex(c => c === BuiltInFieldId.DocTitle);
			this.columnsToDisplay.splice(titleIdx + 1, 0, BuiltInFieldId.Score);
		}
	}

	setFieldsToDisplay() {
		const scoreIdx = this.displayedFieldLayout.fields.findIndex(f => f.fieldId === BuiltInFieldId.Score);

		if (scoreIdx !== -1) {
			this.displayedFieldLayout.fields.splice(scoreIdx, 1);
		}
		if (this.hasActiveSearch) {
			const titleIdx = this.displayedFieldLayout.fields.findIndex(f => f.fieldId === BuiltInFieldId.DocTitle);
			this.scoreFieldViewModel.rank = titleIdx + 1;
			this.displayedFieldLayout.fields.splice(titleIdx + 1, 0, this.scoreFieldViewModel);
		}

		this.columnResizer.tableWidth = this.displayedFieldLayout.fields.map(f => f.width).reduce((sum, current) => sum + current);
	}

	sortByFieldRank(a: any, b: any): number {
		return a.rank > b.rank ? 1 : -1;
	}

	selectSort() {
		const dialogRef = this.dialog.open(SelectSortComponent, {
			width: '600px',
			data: {
				currentSort: this.sortAlert ? this.sortAlert[0] : null,
				ccfManager: this.ccfManager
			}
		});

		dialogRef.afterClosed().subscribe((r: MultiSort) => {
			if (!r) return;

			// Set the alert to display the alert banner
			this.sortAlert = [r, this.sortProcessor.generateDisplayString(r), this.sortProcessor.generateDatabaseString(r)];

			// Set a flag so that the following change to sort doesn't trigger a data refresh
			// (we're just clearing the column sorting indicator since we now have select sort)
			this.disableSortChange = true;

			// Clears any existing column sorting on the table
			this.sort.sort({
				id: '',
				start: 'asc',
				disableClear: true
			});

			this.disableSortChange = false;

			// Load documents at the current page with the new sort order
			this.load();
		});
	}

	sortAlertClear() {
		this.sortAlert = null;
		this.selectionService.deselectAll();
	}

	selectFiltersOld() {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.autoFocus = true;
		dialogConfig.width = '700px';
		dialogConfig.data = {
			ccfManager: this.ccfManager,
			filter: this.selectionService.selectedFilter ? JSON.parse(this.selectionService.selectedFilter.filterJsonOld) : null,
			expanderState: this.filterExpanderState
		};

		const dialogRef = this.dialog.open(SelectFilterComponent, dialogConfig);

		dialogRef.afterClosed().subscribe((data) => {
			this.filterExpanderState = data.expanderState;

			if (data.isCancelled) return;
			if (data.filter) {
				const filter = data.filter as SavedFilters;
				this.textGroupManager.clear();
				this.saveAndSetFilter(filter);
			} else {
				this.clearFilter()
			}
		});
	}

	selectFiltersNew() {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.autoFocus = true;
		dialogConfig.width = '800px';
		dialogConfig.data = {
			filter: this.selectionService.selectedFilter ? JSON.parse(this.selectionService.selectedFilter.filterJson) : null
		};

		const dialogRef = this.dialog.open(SelectFilterNewComponent, dialogConfig);

		dialogRef.afterClosed().subscribe(data => {
			if (!data || data.isCancelled) return;

			if (data.filter) {
				this.textGroupManager.clear();
				this.saveAndSetFilter(data.filter);
			} else {
				this.clearFilter();
			}
		});
	}

	private saveAndSetFilter(filter: SavedFilters | SavedFilter) {
		this.removeAllUrlParams();
		this.filterService.saveFilter(filter).subscribe((r) => {
			this.updateFilter(r);
			this.load(0);
		});
	}

	updateFilter(filter: Filter) {
		delete filter['@odata.context']; // Remove this property to make it a valid Filter type
		this.setFilter(filter);
		this.filterQuickLinks.addRecent(filter);
	}

	exportBriefcase() {
		const config = { data: { expandEmailFamilySelected: this.expandEmailFamilySelected }, panelClass: 'add-docs-to-job-panel' };
		const dialogRef = this.dialog.open(CreateBriefcaseComponent, config);
		dialogRef.afterClosed().subscribe((briefcase: BriefcaseJob) => {
			if (briefcase) {
				briefcase.briefcaseJobDocIds = this.selectionService.selection.selected.map(s => s.docId);
				briefcase.selectAll = this.selectionService.selectAllFlag;
				briefcase.filterId = this.selectionService.getSavedFilterId();
				briefcase.searchParameter = this.searchQuickLinks.searchParameter;
				briefcase.caseId = this.userConfig.currentCase.caseId;
				this.briefcaseManager.createBriefcase(briefcase).subscribe((success) => {
					if (success)
						this.selectionService.operationAlert = 'Briefcase is being created.';
				});
			}
		});
	}

	setFilter(filter: Filter) {
		if (filter.error) {
			this.dialog.open(OkCancelDialogComponent, {
				data: {
					title: 'Filter Error',
					message: `Filter is no longer valid and cannot be applied.`,
					hideCancel: true
				},
				width: '410px'
			}).afterClosed().subscribe();
		} else {
			this.selectionService.selectedFilter = filter;
			this.expandEmailFamilySelected = false;
			if (filter.filterText.includes('Auto Redaction Rule'))
				this.hasAutoRedactionFilter = true;
		}
	}

	setAndLoadFilter(filter: Filter) {
		this.setFilter(filter);
		this.load(0);
	}

	clearFilter() {
		this.selectionService.selectedFilter = null;
		this.expandEmailFamilySelected = false;
		this.textGroupManager.clear();
		this.removeAllUrlParams();
		this.load();
	}

	showFields() {
		const dialogRef = this.dialog.open(SelectFieldsDialogComponent,
			{
				data: {
					// Pass in copies so that the current selection can't be mutated (if the user changes the selection and closes without confirming, we don't want to update the selection)
					view: JSON.parse(JSON.stringify(this.displayedFieldLayout)),
					isSearch: this.hasActiveSearch,
					isLog: false
				}
			});

		dialogRef.afterClosed().subscribe((data: FieldLayoutViewModel) => {
			if (!data) return;

			this.layoutQuickLinks.addNew(data.fields);

			// Only if custom fields are now shown and weren't before do we reload (which will enable custom fields in the result)
			const reload = this.hasCodingField(data.fields) !== this.hasCodingField(this.displayedFieldLayout.fields);

			this.displayedFieldLayout = data;
			this.setColumnsToDisplay();
			this.setFieldsToDisplay();

			if (reload) this.load();
		});
	}

	manageDefaults() {
		this.dialog.open(ManageDefaultsComponent, {
			data: {
				links: this.layoutQuickLinks
			}
		}).afterClosed().subscribe((data: string[]) => {
			let isLinksHaveChanged: boolean = false;
			const sharedAndPinnedLinks = this.layoutQuickLinks.getSharedAndPinnedDeepCopy();
			sharedAndPinnedLinks.forEach(spl => {
				if (data.includes(spl.getLayout().fieldLayoutId) && spl.isPinned && !spl.isShared) {
					spl.isShared = true;
					this.fieldLayoutViewModelService.updateLink(spl).subscribe();
					isLinksHaveChanged = true;
				}
			});

			const recentLinks = this.layoutQuickLinks.getRecentDeepCopy();
			recentLinks.forEach(rl => {
				if (data.includes(rl.getLayout().fieldLayoutId)) {
					rl.isPinned = true;
					rl.isShared = true;
					this.fieldLayoutViewModelService.updateLink(rl).subscribe();
					isLinksHaveChanged = true;
				}
			});

			if (isLinksHaveChanged) this.layoutQuickLinks.set(sharedAndPinnedLinks.concat(recentLinks));
		});
	}

	setLayout(link: LayoutQuickLink) {
		const layout = link.getLayout();
		this.fieldLayoutViewModelService.updateActiveLayout(layout.fieldLayoutId).subscribe(() => {
			this.displayedFieldLayout = layout;
			this.setColumnsToDisplay();
			this.setFieldsToDisplay();
			this.load();
		});
	}

	toolbarPrevPage() {
		this.paginator.previousPage();
	}

	toolbarNextPage() {
		this.paginator.nextPage();
	}

	toggleExpandEmailFamily() {
		this.expandEmailFamilySelected = !this.expandEmailFamilySelected;
		this.load();
	}

	public disableAiPanel(): boolean {
		if (!this.selectionService.selection.selected.length) {
			if (this.enableKnowledgeBase)
				return false;
			else
				return true;
		}

		if (this.userConfigService.inRoles(Role.Employee))
			return false;

		return !this.isOpenAiLinked;
	}

	public openAiPanel() {
		if (this.enableKnowledgeBase && !this.selectionService.selection.selected.length) {
			this.openPilot();
		}
		else {
			this.openCoPilot();
		}
	}

	public displayAiTooltip() {
		if (this.enableKnowledgeBase && !this.selectionService.selection.selected.length) {
			return 'Pilot';
		}
		return 'CoPilot';
	}

	public openPilot() {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.width = '1000px';
		dialogConfig.height = '600px';
		dialogConfig.autoFocus = false;
		this.dialog.open(AiPilotPromptComponent, dialogConfig).afterClosed().subscribe();
	}

	public openCoPilot() {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.width = '1000px';
		dialogConfig.height = '90vh';
		dialogConfig.autoFocus = false;
		let sortBy;
		if (this.sort.active && this.sort.direction) {
			sortBy = this.sort.active + ' ' + this.sort.direction;
		} else if (this.sortAlert) {
			sortBy = this.sortAlert[2];
		}
		dialogConfig.data = {
			searchParameter: this.searchQuickLinks.searchParameter,
			expandEmailFamilySelected: this.expandEmailFamilySelected,
			sortBy: sortBy
		};
		this.dialog.open(AiMultiDocPromptComponent, dialogConfig).afterClosed().subscribe();
	}

	setPage(inputValue: number) {
		let validatedValue = Math.abs(inputValue);

		if (validatedValue === 0)
			validatedValue = 1;
		else if (validatedValue > this.selectionService.dataSource.totalPages)
			validatedValue = this.selectionService.dataSource.totalPages;

		this.load(validatedValue - 1);
	}

	/**
	 * Deselects every document before reloading the current page (or specified page) with current sorting (either column or select sort) and filter (if one exists).
	 */
	load(pageIndex = this.paginator.pageIndex, deselectAll = true) {
		if (deselectAll)
			this.selectionService.deselectAll();

		const filterId = this.selectionService.getSavedFilterId();
		let sort: string = null;
		if (this.sort.active && this.sort.direction) {
			sort = this.sort.active + ' ' + this.sort.direction;
		} else if (this.sortAlert) {
			sort = this.sortAlert[2];
		}

		const includeCustomCodingFields = this.displayedFieldLayout.fields.some(f => f.fieldType >= 0);
		const includeFolderPath = !!this.displayedFieldLayout.fields.find(f => f.fieldId === BuiltInFieldId.Folder);
		const includeCustodianName = !!this.displayedFieldLayout.fields.find(f => f.fieldId === BuiltInFieldId.Custodian);
		const includeReviewerNames = !!this.displayedFieldLayout.fields.find(f => f.fieldId === BuiltInFieldId.HasBeenReviewed);
		let selectionInfo = {
			selectAll: false,
			selectedDocIds: new Array<string>()
		};
		if (!deselectAll)
			selectionInfo = {
				selectAll: this.selectionService.selectAllFlag,
				selectedDocIds: this.selectionService.selection.selected.map(s => s.docId) as string[]
			};

		setTimeout(() => this.selectionService.dataSource.loadDocsSubscription(
			pageIndex,
			this.selectionService.pageSize,
			sort, filterId,
			includeCustomCodingFields,
			includeFolderPath,
			includeCustodianName,
			includeReviewerNames,
			this.expandEmailFamilySelected,
			this.hasActiveSearch,
			this.searchQuickLinks.searchParameter.searchString,
			this.saveSearch)
			.pipe(tap(() => {
				this.selectionService.selectDocsFromQueryParam();
				if (!deselectAll) this.selectionService.selectDocsFromSelectionInfo(selectionInfo);
				if (this.saveSearch) this.searchQuickLinks.refresh();
				if (this.selectionService.dataSource.truncatedResult) this.truncatedResult = true;
			})).subscribe());

		this.paginator.pageIndex = pageIndex;
		this.loadFolderNavigation();
	}

	getCustomFieldValue(row: any, field: Field) {
		if (row.customCodingFields) {
			const custField = row.customCodingFields.find(r => r.fieldId === field.fieldId);
			if (custField) return this.getProp(custField, field.path);
		}
	}

	getProp(obj: any, path: string) {
		let last = obj;
		path.split('.').forEach((prop: string) => {
			last = last[prop];
			if (prop === 'responsive') {
				last = DocCoding.responsiveToString(last);
			} else if (prop.toLowerCase() === 'batesnumberstart') {
				const bates = obj['bates'];
				const common = obj['common'];
				last = DocBates.batesStampString(bates['batesPrefix'], bates['batesNumberStart'], bates['batesNumberDigits'], common['pageCount']);
			} else if (prop.toLowerCase() === 'controlnumber' || prop.toLowerCase() === 'textgroupid') {
				if (last <= 0)
					last = '';
			} else if (path.toLowerCase() === 'emailtype.displayname' && prop.toLowerCase() === 'displayname') {
				last = (last === 'EmailAttachment');
			} else if (prop.toLowerCase() === 'docsize') {
				const docSizeFormatted = new ByteSize(last);
				last = `${docSizeFormatted.sizeInMegabytes} MB`;
			}
		});
		return last;
	}

	getIssueString(obj: any): string {
		let placeholderString = '';

		const placeholder = obj['status']['issues'];
		if (placeholder) {
			placeholderString = DocIssueTypeExtension.getIssueDisplayString(<DocIssueType>placeholder);
		}
		return placeholderString;
	}

	exportLog() {
		const requestBody: ExportLog = new ExportLog();
		requestBody.docIds = this.selectionService.selection.selected.map(s => s.docId);
		requestBody.filterId = this.selectionService.getSavedFilterId();
		requestBody.selectAll = this.selectionService.selectAllFlag;
		requestBody.searchParameter = this.searchQuickLinks.searchParameter;
		requestBody.expandToEmailFamily = this.expandEmailFamilySelected;
		this.exportingLog = true;
		this.notificationManager.displaySnackBarMessage(
			{
				message: 'Exporting log to Excel...',
				type: 'info',
				ttl: 3000
			})
		this.exportService.exportLog(requestBody)
			.subscribe((url) => {
				this.exportingLog = false;
				window.open(url, '_blank');
			},
				err => {
					this.exportingLog = false;
					if (err.status === 400)
						this.notificationManager.displaySnackBarMessage(
							{
								message: 'Selected number of documents and fields exceeds system limit, please contact Professional Services for support.',
								type: 'error',
								ttl: 10000
							})
					else if (err.status === 504)
						this.notificationManager.displaySnackBarMessage(
							{
								message: 'Export log to Excel request timed out, please contact Professional Services for support.',
								type: 'error',
								ttl: 10000
							})
					else
						catchError(this.errorHandler.handleError<string>('Failed to Export Log'));
				});
	}

	loadFolderNavigation() {
		if (this.previousFilterId === this.selectionService.getSavedFilterId()) return;

		if (this.selectionService.selectedFilter) {
			// The user has a filter applied
			const filterFolderId = this.getFilterValue(BuiltInFieldId.Folder);
			if (filterFolderId) {
				this.folderService.getChildrenOf(filterFolderId).subscribe(folders => {
					if (folders) this.folderNavigationList = folders.value;
				});
			} else {
				this.getRootAndChildrenFolders();
			}
		} else {
			// if there is no filter active with a folder, then get the root folder
			this.getRootAndChildrenFolders();
		}

		this.previousFilterId = this.selectionService.getSavedFilterId();
	}

	async getRootAndChildrenFolders() {
		if (!this.rootFolderId) {
			this.rootFolderId = (await this.folderService.getRootFolder().toPromise()).value[0].folderId;
		}

		const children = (await this.folderService.getChildrenOf(this.rootFolderId).toPromise()).value;
		if (children) {
			this.folderNavigationList = children;
		}
	}

	navigateFolder(folderId: string) {
		const isRootFolder = folderId === this.rootFolderId;

		// The user has a filter applied
		let activeFilter: SavedFilter;
		if (this.selectionService.selectedFilter) {
			activeFilter = JSON.parse(this.selectionService.selectedFilter.filterJson);
		}

		// Clear filter if it is the RootFolder and only active filter
		if (isRootFolder && activeFilter && activeFilter.fields.length === 1 && this.getFilterValue(BuiltInFieldId.Folder) != null) {
			this.selectionService.selectedFilter = null;
			this.expandEmailFamilySelected = false;
			this.load();
		} else if (!isRootFolder) {
			this.saveAndSetFilter(this.createOrUpdateFilter(BuiltInFieldId.Folder, FieldDisplayType.Text, [folderId]));
		}
	}

	navigateUpFolder() {
		if (this.selectionService.selectedFilter) {
			const filterFolderId = this.getFilterValue(BuiltInFieldId.Folder);
			if (filterFolderId) {
				this.folderService.getFolder$(filterFolderId).subscribe(data => {
					if (data) {
						this.navigateFolder(data.parentFolderId);
					}
				});
			}
		}
	}

	doSearch(newSearch: boolean) {
		this.hasActiveSearch = true;
		this.sort.active = null;
		this.verifyQuerySyntax();
		this.saveSearch = newSearch;
		this.setColumnsToDisplay();
		this.setFieldsToDisplay();
		this.load(0);
		this.invalidQuery = false;
		this.timeoutAlert = false;
		this.noDocuments = false;
		this.truncatedResult = false;
	}

	setSearch(search: SavedSearch) {
		this.searchQuickLinks.searchParameter = new SearchParameter(search.searchString);
		this.doSearch(false);
	}

	closeSearch() {
		this.hasActiveSearch = false;
		this.searchQuickLinks.searchParameter.searchString = null;
		this.searchQuickLinks.searchControl.setValue('');
		this.sort.active = this.builtInFieldIds.DocTitle;
		this.setColumnsToDisplay();
		this.setFieldsToDisplay();
		this.load(0);
	}

	showQuickLinkManagement(type: string, typePlural: string, links: QuickLinks, service: QuickLinkUpdate) {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.data = {
			type: type,
			typePlural: typePlural,
			links: links,
			update: service,
			userId: this.userConfig.userId,
			userRoles: this.userRoles
		};

		const dialogRef = this.dialog.open(QuickLinkManagementComponent, dialogConfig);

		dialogRef.afterClosed().subscribe((data: QuickLink[]) => {
			if (data) links.set(data);
		});
	}

	/** Displays a warning using the operationalAlert if search query contains deprecated Legacy syntax.
	 * Legacy syntax: https://help.relativity.com/10.3/Content/Relativity/dtSearch/Using_dtSearch_syntax_options.htm#Numerica
	 * OpenSearch syntax: https://www.elastic.co/guide/en/elasticsearch/reference/current/query-dsl-query-string-query.html#query-string-syntax
	 */
	verifyQuerySyntax() {
		const alert = this.browseManager.verifyOpenSearchQuerySyntax(this.searchQuickLinks.searchParameter.searchString);
		if (alert.length > 0)
			this.syntaxWarning.next('Warning: ' + alert);
		else
			this.syntaxWarning.next('');
	}

	public clearSyntaxWarning() {
		this.syntaxWarning.next('');
	}

	saveLayoutAs(link: LayoutQuickLink) {
		this.dialog.open(OkCancelDialogComponent, {
			data: {
				title: 'Save Confirmation',
				message: `Save current layout as '${link.title}'?`
			},
			width: '400px'
		}).afterClosed().subscribe((okClicked: boolean) => {
			if (okClicked) {
				link.getLayout().fields = this.displayedFieldLayout.fields;
				this.fieldLayoutViewModelService.updateLink(link).subscribe();
			}
		});
	}

	isDisableSaveLayout(createdById: string): boolean {
		if (!this.userRoles)
			return false;

		return !this.userRoles.includes(Role.AccountFeatureSet) && this.userConfig.userId !== createdById;
	}

	isEmailThreadFilter(): boolean {
		return this.getFilterValue(FilterFieldGuids.EmailThreadId) != null;
	}

	visualizeEmailThread() {
		window.location.href = 'EmailThread/' + this.getFilterValue(FilterFieldGuids.EmailThreadId);
	}

	prevEmailThread() {
		const emailThreadId = this.getFilterValue(FilterFieldGuids.EmailThreadId);
		this.emailThreadService.getPrevThread(emailThreadId).subscribe(prevThreadId => {
			if (prevThreadId !== emailThreadId) {
				this.saveAndSetFilter(this.createOrUpdateFilter(FilterFieldGuids.EmailThreadId, FieldDisplayType.Text, [prevThreadId]));
			}
		});
	}

	nextEmailThread() {
		const emailThreadId = this.getFilterValue(FilterFieldGuids.EmailThreadId);
		this.emailThreadService.getNextThread(emailThreadId).subscribe(nextThreadId => {
			if (nextThreadId !== emailThreadId) {
				this.saveAndSetFilter(this.createOrUpdateFilter(FilterFieldGuids.EmailThreadId, FieldDisplayType.Text, [nextThreadId]));
			}
		});
	}

	getFilterValue(fieldId: string): string {
		if (!this.selectionService.selectedFilter) return;

		const filter: SavedFilter = JSON.parse(this.selectionService.selectedFilter.filterJson);

		const match = filter.fields.find(f => f.fieldId === fieldId);

		if (match) return match.value[0];
	}

	/** Creates a filter for the specified field with the specified value if a filter does not already exist.
	 *  If a filter already exists, field is added if field does not exist. If field exists, value is updated.
	 */
	createOrUpdateFilter(fieldId: string, displayType: FieldDisplayType, value: string[]): SavedFilter {
		return this.browseManager.createOrUpdateFilter(fieldId, displayType, value);
	}

	public refreshBrowse() {
		this.load();
		//TODO: Refactor code. This is a temp workaround
		const refreshWaitForQuickWorkflow = 1500;
		if (this.refresh.length === 0)
			setTimeout(() => {
				this.needRefresh = true;
			}, refreshWaitForQuickWorkflow);
	}

	private removeAllUrlParams() {
		this.activatedRoute.queryParams
			.pipe(take(1))
			.subscribe((params) => {
				if (Object.keys(params).length > 0) {
					this.router.navigate([], {
						relativeTo: this.activatedRoute,
						queryParams: {}
					});
				}
			});
	}

}
